(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const formatString = format || '${{amount}}';
    const amount = (Number(cents) / 100).toFixed(2);
    const amountNoDecimals = (Number(cents) / 100).toFixed(0);
    const amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountNoDecimalsWithComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return formatString
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getVariantPicker(section) {
    return section.querySelector('variant-radios, variant-selects');
  }

  function getVariantData(section) {
    const picker = getVariantPicker(section);
    if (!picker) return [];
    const json = picker.querySelector('[type="application/json"]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent);
    } catch {
      return [];
    }
  }

  function getCurrentVariant(form, section) {
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return null;
    return getVariantData(section).find((variant) => String(variant.id) === String(variantId)) || null;
  }

  function getQuantity(form) {
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = parseInt(quantityInput?.value || '1', 10);
    return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function hasUnselectedOptions(section) {
    const picker = getVariantPicker(section);
    if (!picker) return false;

    const selects = Array.from(picker.querySelectorAll('select'));
    if (selects.length) {
      return selects.some((select) => !select.value);
    }

    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    if (fieldsets.length) {
      return fieldsets.some((fieldset) => !fieldset.querySelector('input[type="radio"]:checked'));
    }

    return false;
  }

  function updateQuantityLabel(form) {
    const labelEl = form.querySelector('.pdp-buy-row__quantity-label');
    const unit = form.dataset.quantityUnitLabel;
    if (!labelEl || !unit || typeof pluralize !== 'function') return;

    labelEl.textContent = pluralize(unit, getQuantity(form));
  }

  function updatePdpAtcButton(form) {
    const button = form.querySelector('[data-pdp-atc]');
    if (!button) return;

    const section = form.closest('.main-product-pdp');
    if (!section) return;

    const priceEl = button.querySelector('.pdp-atc-button__price');
    const separatorEl = button.querySelector('.pdp-atc-button__separator');
    const textEl = button.querySelector('.pdp-atc-button__text');
    const variant = getCurrentVariant(form, section);
    const moneyFormat = form.dataset.moneyFormat;
    const addToCartLabel = form.dataset.addToCartLabel || 'Add to cart';
    const soldOutLabel = form.dataset.soldOutLabel || 'Sold out';
    const unavailableLabel = form.dataset.unavailableLabel || 'Unavailable';
    const selectRequiredLabel = form.dataset.selectRequiredLabel || unavailableLabel;
    const requiresVariantSelection = form.dataset.requireVariantSelect === 'true';

    if (requiresVariantSelection && hasUnselectedOptions(section)) {
      if (priceEl) priceEl.hidden = true;
      if (separatorEl) separatorEl.hidden = true;
      if (textEl) {
        textEl.hidden = false;
        textEl.textContent = selectRequiredLabel;
      }
      return;
    }

    if (!variant || !variant.available) {
      if (priceEl) priceEl.hidden = true;
      if (separatorEl) separatorEl.hidden = true;
      if (textEl) {
        textEl.hidden = false;
        if (!variant) {
          textEl.textContent = requiresVariantSelection && hasUnselectedOptions(section)
            ? selectRequiredLabel
            : unavailableLabel;
        } else {
          textEl.textContent = soldOutLabel;
        }
      }
      return;
    }

    const totalCents = variant.price * getQuantity(form);
    if (priceEl) {
      priceEl.hidden = false;
      priceEl.textContent = formatMoney(totalCents, moneyFormat);
      priceEl.dataset.unitPrice = variant.price;
    }
    if (separatorEl) separatorEl.hidden = false;
    if (textEl) {
      textEl.hidden = false;
      textEl.textContent = addToCartLabel;
    }
  }

  function initPdpBuyButtons() {
    document.querySelectorAll('product-form.product-form--pdp').forEach((form) => {
      const section = form.closest('.main-product-pdp');
      if (!section) return;

      const refresh = () => {
        updateQuantityLabel(form);
        updatePdpAtcButton(form);
      };
      refresh();

      form.querySelector('[name="quantity"]')?.addEventListener('change', refresh);
      form.querySelector('[name="quantity"]')?.addEventListener('input', refresh);
      getVariantPicker(section)?.addEventListener('change', () => {
        requestAnimationFrame(refresh);
      });
      form.querySelector('[name="id"]')?.addEventListener('change', refresh);
      form.addEventListener('pdp-atc:refresh', refresh);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpBuyButtons);
  } else {
    initPdpBuyButtons();
  }
})();
